import { debounce, isObject } from '@local/utils'

interface DebounceSettings {
  leading?: boolean
  maxWait?: number
  trailing?: boolean
}

function throttle<F extends (...args: any[]) => void>(func: F, wait = 1, options?: DebounceSettings): F {
  let leading = true,
    trailing = true

  if (typeof func != 'function') {
    throw new TypeError('Expected a function')
  }

  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading
    trailing = 'trailing' in options ? !!options.trailing : trailing
  }

  return debounce(func, wait, {
    leading: leading,
    maxWait: wait,
    trailing: trailing,
  }) as unknown as F
}

export default throttle
